import React from 'react'
import BackToUp from '@uiw/react-back-to-top';
import Bnne from '../components/organic1/bnne/Bnne'
import TrendingProducts from '../components/index/trending_products/TrendingProducts'
import FeaturedProducts from '../components/organic1/featured_products/FeaturedProducts';
import ChooseUs from '../components/organic1/choose_us/ChooseUs';
import HealthyLife from '../components/organic1/healthy_life/HealthyLife';
import Products from '../components/organic1/product/Products';
import DealWeek from '../components/organic1/deal_week/DealWeek';
import ProductsTop from '../components/organic1/products_top/ProductsTop';
import ProductVews from '../components/organic1/product_vews/ProductVews';
import Testimonial from '../components/organic1/testimonial/Testimonial';
import LatestBlog from '../components/organic1/latest_blog/LatestBlog';
const Desktop1 = () => {
  return (
    <>
    <Bnne/>
    <TrendingProducts/>
    <FeaturedProducts/>
    <ChooseUs/>
    <HealthyLife/>
    <Products/>
    <DealWeek/>
    <ProductsTop/>
    <ProductVews/>
    <Testimonial/>
    <LatestBlog/>
    <div className="container">
      <BackToUp><i class="fa-solid fa-arrow-up"></i></BackToUp>
    </div>
    </>
  )
}

export default Desktop1